import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'

const ACTION = 'getMySpacesPayments'

// Antwort der partnerControl-Action prüfen und auspacken. Der Dispatcher im
// Backend überspringt unregistrierte Funktionen still und liefert dann
// res: {}, deshalb muss die Form stimmen. Jeder Verstoß ist ein Fehler, denn
// aus einer halben Antwort darf kein Standortwechsel folgen.
export const parseSpacesAccess = (data) => {
  const parsed = typeof data === 'string' ? JSON.parse(data) : data
  const result = parsed?.body?.[ACTION]?.res

  const isValid =
    Array.isArray(result?.spaces) &&
    result.spaces.every(
      (space) =>
        typeof space?.space_id === 'string' && Array.isArray(space.payments)
    )

  if (!isValid) throw new Error(`${ACTION}: unerwartete Antwort`)

  return { spaces: result.spaces, truncated: result.truncated === true }
}

// Zugang aller eigenen Standorte, die Payments liefert das Backend roh. Die
// Antwort entscheidet über einen automatischen Wechsel und kommt deshalb nie
// aus dem Cache (gcTime 0, in src/index.js von der Persistierung
// ausgenommen), wird nie wiederholt und nie im Hintergrund erneuert.
export const useSpacesAccess = ({ username, enabled }) =>
  useQuery({
    queryKey: QUERY_KEYS.spacesAccess(username),
    queryFn: async () =>
      parseSpacesAccess(
        await query({ query: ACTION, variables: { action: ACTION } })
      ),
    enabled: !!username && enabled,
    retry: false,
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  })
